export const CONUS_CENTER = { lat: 39.8283, lng: -98.5795 } as const;
export const CONUS_CENTER_COORDS = [
  CONUS_CENTER.lng,
  CONUS_CENTER.lat,
] as const;
